// Short French time labels shared by the home page and the navbar.
const pad = (value) => String(value).padStart(2, '0');
const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

const DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
const MONTHS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];

// « 9:05 »
export const clockLabel = (date) => `${date.getHours()}:${pad(date.getMinutes())}`;

// « 9 h 05 »
export const hourLabel = (date) => `${date.getHours()} h ${pad(date.getMinutes())}`;

// « 45 min », « 1 h », « 1 h 30 »
export const durationLabel = (minutes) =>
  minutes < 60
    ? `${minutes} min`
    : `${Math.floor(minutes / 60)} h${minutes % 60 ? ` ${pad(minutes % 60)}` : ''}`;

// « Mardi 21 Octobre 26 », the title of the home page.
export const dayTitle = (date) =>
  `${capitalize(DAYS[date.getDay()])} ${date.getDate()} ${capitalize(
    MONTHS[date.getMonth()],
  )} ${String(date.getFullYear()).slice(2)}`;

// « Octobre 2026 », the head of a month in a history.
export const monthTitle = (date) => `${capitalize(MONTHS[date.getMonth()])} ${date.getFullYear()}`;

// The local day of a date, as the api writes days: « 2026-10-21 ».
export const isoDay = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

// « 15 oct. », for a day written « 2026-10-15 ».
export const shortDayLabel = (day) => {
  const [year, month, date] = day.split('-').map(Number);
  return new Date(year, month - 1, date, 12).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
  });
};

export const addDays = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

const DAYS_SHORT = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'];

// « Mar. 21 oct. »
export const dayLabel = (date) =>
  `${DAYS_SHORT[date.getDay()]} ${date.getDate()} ${date
    .toLocaleDateString('fr-FR', { month: 'short' })}`;

// A day written « 2026-10-21 », as a local date at noon (no time zone slip).
export const fromIsoDay = (day) => {
  const [year, month, date] = day.split('-').map(Number);
  return new Date(year, month - 1, date, 12);
};

// « 9:30 », « 9h30 », « 930 » → [9, 30]; anything else, null.
export const parseClock = (value) => {
  const match = /^(\d{1,2})\s*(?:[:hH.]\s*(\d{2})?|(\d{2}))?$/.exec(value.trim());
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2] ?? match[3] ?? 0);
  return hours < 24 && minutes < 60 ? [hours, minutes] : null;
};
